'use strict';

import React, { Component } from 'react';
import ValidationOverlay from '../validationOverlay.jsx';
import { Button, ListItem, ListItemIcon, ListItemText, Typography, TableRow, TableBody, TableCell, Box } from '@material-ui/core';
import { Settings, AccountBoxRounded } from '@material-ui/icons';
import { MiniCard } from '../../../commonModules/layouts/CardPage.jsx';
import { TableLayout } from '../Stock/containers/Layout.jsx';
import Dialog from '../../../commonModules/interface/Dialog.jsx';
import { InputSelect } from '../../../commonModules/interface/form-input-inline.jsx';

class CommercialInCharge extends Component{
    emptyTable = [
        {
            id: "",
            value: ""
        }
    ]
    state = {
        //Initiate Time for the chart
        
        subList: 'dl-horizontal hidden',
        subList: false,

        commerciallistValue: "",
        subscriptionlist: this.emptyTable,
        errmsg: '',
        msg: '',
        url: '',
        popupStateValidation: false,
        actualCommercial: '',
        sellerCommecial: '',
    }
    componentDidMount= async () =>  {
        //Get Info on actual
        this.getCommercialInfo()
        this.getCommercialList()
    }
    getCommercialInfo = async () => {
        var url = "/commercial/manager/info?boxAssoId=" + this.props.boxAssoId;
        try {
            let req = await fetch(url,{
                method:'GET',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                },
                credentials: 'same-origin',
       
            })
            const res = await req.json()
            console.log({res});
            
            if(res.error === "OK"){

                this.setState({actualCommercial: res.actualCommercial, sellerCommecial: res.sellerCommecial});
            } else {
                console.log("[ERROR] handleSubmitCustom ", res.error);
            }
        } catch (error) {
            console.log('====================================');
            console.log("[ERROR] handleSubmitCustom ", error);
            console.log('====================================');
        }
    }
    getCommercialList = async () =>{
        var url = "/agent/list" ;
        try {
            let req = await fetch(url,{
                method:'GET',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                },
                credentials: 'same-origin',
       
            })
            const res = await req.json()
            console.log({res});
            
            if(res.error === "OK"){
                var optionTmp = [];
                for (var i = 0; i < res.contentJs.length; i += 1) {
                    optionTmp.push({id: res.contentJs[i].name, idobj: res.contentJs[i].id})
                }
                this.setState({subscriptionlist: optionTmp, subscriptionlistValue: ""});
            } else {
                console.log("[ERROR] handleSubmitCustom ", res.error);
            }
        } catch (error) {
            console.log('====================================');
            console.log("[ERROR] handleSubmitCustom ", error);
            console.log('====================================');
        }
    }
    handleSubmit = async () => {
        console.log('Change Subscription request for ', this.props.boxId, ' or ', this.props.userId);
        //Open a windows to choose Subscription Demande de confirmation
        var subscriptionId = "";
        for (var i = 0; i < this.state.subscriptionlist.length; i += 1) {
            if (this.state.subscriptionlist[i].id === this.state.commerciallistValue) {
                subscriptionId = this.state.subscriptionlist[i].idobj;
            }
        }
        if (subscriptionId === '') {
            this.setState({errmsg: "Le commercial ne peut être absent. Ou es-tu commercial ?"});
            return;
        }
        var url = "/commercial/incharge/change?boxAssoId=" + this.props.boxAssoId + "&userId=" + this.props.userId + "&subscription=" + subscriptionId;
        var msg = "Changement de commercial vers : " + this.state.commerciallistValue;
        //Active Pop up Security
        this.setState({popupStateValidation: true, msg: msg, url: url});

    }
    cancelSubmit = async () => {
        console.log('Cancel Change Subscription request for ', this.props.boxId, ' or ', this.props.userId);
        this.setState({subList: false});
    }
    requestSubmit = async () => {
        console.log('Request Change Subscription request for ', this.props.boxId, ' or ', this.props.userId);
        this.setState({subList: true});
    }
    onChangeSubscription = async (e) => {
        var value = e.value;
        this.setState({commerciallistValue: value});
    }
    onValidationSucceed = async () => {
        this.setState({
            subList: false, 
            errmsg: 'succes change', 
            popupStateValidation: false,
            actualCommercial: this.state.commerciallistValue
        });
    }
    onCancelation = async () => {
        this.setState({
            popupStateValidation: false,
        });
    }
    render () {
        const { subscriptionlist } = this.state;
        return (
            <MiniCard
                avatar={ <AccountBoxRounded /> }
                title="Commercial"
            >
                <TableLayout>
                    <TableBody>
                        <TableRow>
                            <TableCell component="th">Commercial Vendeur</TableCell>
                            <TableCell>{this.state.sellerCommecial}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell component="th">Commercial actuel</TableCell>
                            <TableCell>{this.state.actualCommercial}</TableCell>
                        </TableRow>
                    </TableBody>
                </TableLayout>

                {!this.state.subList &&
                <Box p={1}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={this.requestSubmit}
                    >
                        Changer Commercial en Charge
                    </Button>
                </Box>
                }
                {this.state.subList &&
                    <Dialog
                        block={true}
                        title="Changer Commercial"
                        submitAction={this.handleSubmit}
                        close={this.cancelSubmit}
                    >
                        <InputSelect
                            value={this.state.commerciallistValue}
                            onChange={this.onChangeSubscription}
                            options={subscriptionlist.map( optionval => (
                                {value: optionval.id, label:optionval.id, title:optionval.id}
                                ))
                            }
                        />
                    </Dialog>
                }
                {this.state.errmsg}
                {this.state.popupStateValidation &&
                    <ValidationOverlay
                        msg={this.state.msg}
                        // popupStateButton={this.state.popupStateValidation}
                        url={this.state.url}
                        onValidation={this.onValidationSucceed}
                        onCancelation={this.onCancelation}
                    />
                }

            </MiniCard>

            // <div>
            //     <dl className="dl-horizontal">
            //         <dt>Commercial Vendeur</dt>
            //         <dd>{this.state.sellerCommecial}</dd>
            //     </dl>
            //     <dl className="dl-horizontal">
            //         <dt>Commercial actuel</dt>
            //         <dd>{this.state.actualCommercial}</dd>
            //     </dl>
                
            //     {!this.state.subList &&
            //     <div className="pmbb-body p-l-30 " >
            //         <Button
            //             variant="contained"
            //             color="secondary"
            //             onClick={this.requestSubmit}>Changer Commercial en Charge</Button>
            //     </div>
            //     }
            //     {this.state.subList &&
            //     <React.Fragment>

            //         <dl className="pmbb-body p-l-30" >
            //             <dt className="p-t-10">Changer Commercial</dt>
            //             <dd>
            //                 <div className="fg-line">
            //                     <select
            //                         className="form-control"
            //                         value={this.state.commerciallistValue}
            //                         onChange={this.onChangeSubscription}>
            //                         {subscriptionlist.map( optionval => (
            //                             <option key={optionval.id} value={optionval.id}>{optionval.id}</option>
            //                         ))
            //                     }
            //                     </select>
            //                 </div>
            //             </dd>
            //         </dl>
            //         <div className="pmbb-body p-l-30" >
            //             <Button
            //                 color="secondary"
            //                 onClick={this.cancelSubmit}>Annuler</Button>
            //             <Button
            //                 color="secondary"
            //                 variant="contained"
            //                 onClick={this.handleSubmit}>Changer Commercial en Charge</Button>
            //         </div>
            //     </React.Fragment>
            //     }
            // </div>

        )
    }
};
export default CommercialInCharge
